/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'ellipsis': {
    viewBox: '0 0 24 24',
    data: `<path d="M12,6a1,1,0,1,1-1,1A1,1,0,0,1,12,6Zm0,5a1,1,0,1,1-1,1A1,1,0,0,1,12,11Zm0,5a1,1,0,1,1-1,1A1,1,0,0,1,12,16Z" style="fill-rule:evenodd"/>`
  }
})
